import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from "react-toastify";
import { apiConnector } from "../apiConnector";
import { endpoint } from "../apis";
import Cookies from 'js-cookie';

export const fetchChartData = (chartName, apiEndpoint) => createAsyncThunk(
    `charts/${chartName}`,
    async ({ selectedDays, selectedChannelId, selectedTitles, Table }, { rejectWithValue }) => {
        // Prioritize jwt_token; fallback to token
        const token = localStorage.getItem('jwt_token') || Cookies.get('authToken');;
        // const token = Cookies.get('authToken');

        try {
            const response = await apiConnector(
                "POST",
                apiEndpoint,
                {
                    channel_id: selectedChannelId,
                    filter_type: selectedDays,
                    table: Table,
                },
                { Authorization: `Bearer ${token}` },
                null,
            );

            const data = (response.data.response);

            // toast.success(`${chartName} data fetched successfully!`)
            return data;
        } catch (error) {
            if (error?.response?.data == "('Token has been expired',)") {
                localStorage.clear();
                window.location.href = '/';
                toast.error('Session expired. Please log in again.');
            } else {
                toast.error(error?.response?.data || 'Failed to fetch channels!');
            }
            return rejectWithValue(error?.response?.data)
        }
    }
);

export const fetchVideoPerformanceKPIData = () => createAsyncThunk(
    "fetchVideoCardData",
    async ({ selectedDays, selectedChannelId, Table }, { rejectWithValue }) => {
        // Prioritize jwt_token; fallback to token
        // const token = localStorage.getItem('jwt_token') || localStorage.getItem('token');
        // const token = Cookies.get('authToken');
        const token = localStorage.getItem('jwt_token') || Cookies.get('authToken');;

        try {
            const response = await apiConnector(
                "POST",
                endpoint.VideoPerformCardKPI,
                {
                    channel_id: selectedChannelId,
                    filter_type: selectedDays,
                    table: Table,
                },
                { Authorization: `Bearer ${token}` },
                null,
            );

            const data = (response.data.response);

            return data;
        } catch (error) {
            if (error?.response?.data == "('Token has been expired',)") {
                localStorage.clear();
                window.location.href = '/';
                toast.error('Session expired. Please log in again.');
            } else {
                toast.error(error?.response?.data || 'Failed to fetch channels!');
            }
            return rejectWithValue(error?.response?.data)
        }
    }
);


// Here we are calling all the same function for all the charts

export const fetchChart1Data = fetchChartData('fetchChart1Data', endpoint.VIDEO_PERFORMANCE_CHART1);
export const fetchChart2Data = fetchChartData('fetchChart2Data', endpoint.VIDEO_PERFORMANCE_CHART2);
export const fetchChart3Data = fetchChartData('fetchChart3Data', endpoint.VIDEO_PERFORMANCE_CHART3);
export const fetchChart4Data = fetchChartData('fetchChart4Data', endpoint.VIDEO_PERFORMANCE_CHART4);
export const fetchChart5Data = fetchChartData('fetchChart5Data', endpoint.VIDEO_PERFORMANCE_CHART5);
export const fetchChart6Data = fetchChartData('fetchChart6Data', endpoint.VIDEO_PERFORMANCE_CHART6);
export const fetchChart7Data = fetchChartData('fetchChart7Data', endpoint.VIDEO_PERFORMANCE_CHART7);
export const fetchChart8Data = fetchChartData('fetchChart8Data', endpoint.VIDEO_PERFORMANCE_CHART8);
export const fetchChart9Data = fetchChartData('fetchChart9Data', endpoint.VIDEO_PERFORMANCE_CHART9);